import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaCheckCircle } from 'react-icons/fa';
import { FunctionComponent } from 'react';

interface Props {
  isLoggedIn: boolean;
}

const EmailConfirmation: React.FC<Props> = ({ isLoggedIn }) => {
  const navigate = useNavigate();
  const FaCheckCircleIcon = FaCheckCircle as FunctionComponent<{ className?: string }>;

  const handleContinue = () => {
    navigate(isLoggedIn ? '/profile' : '/login');
  };

  return (
    <div className="bg-background min-h-screen">
      <Helmet>
        <title>EatMeat - Email Confirmed</title>
        <meta
          name="description"
          content="Your email address has been successfully confirmed. Continue to log in or access your EatMeat profile."
        />
      </Helmet>

      <section className="bg-caption-bg py-16">
        <div className="container mx-auto px-6 max-w-md">
          <div className="mb-6">
            <Link
              to="/"
              className="text-primary underline font-semibold hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent"
              aria-label="Back to Home"
            >
              ← Back to Home
            </Link>
          </div>

          <div className="bg-background p-6 rounded-lg shadow-md text-center">
            <h1 className="text-2xl md:text-3xl font-bold mb-4 text-text flex items-center justify-center">
              <FaCheckCircleIcon className="mr-3 text-primary h-8 w-8" />
              Email Confirmed
            </h1>
            <p className="text-text mb-6">
              Your email address has been successfully verified! You're now ready to explore all the features of EatMeat.
            </p>
            <button
              onClick={handleContinue}
              className="bg-primary text-background p-3 rounded-lg font-semibold form-button hover:bg-accent focus:outline-none focus:ring-2 focus:ring-accent"
              aria-label={isLoggedIn ? 'Go to Profile' : 'Go to Login'}
            >
              {isLoggedIn ? 'Go to Profile' : 'Log In Now'}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmailConfirmation;